import { getPartnerToken } from '@/services/auth/partnerSessionStorage';
import axios from 'axios';

let readContext = () => ({
  token: typeof localStorage !== 'undefined' ? getPartnerToken() : null,
  mode: 'CLOUD_MODE',
});

export function configureRestaurantPrintTransport(resolver) {
    readContext = resolver;
}

export function restaurantPrintMode() {
  return readContext().mode;
}

export function usesRestaurantPrintTransport(payload = {}) {
  const { mode } = readContext();
  return Boolean(payload.metadata?.print_event)
    && !['LOCAL_MODE', 'LOCAL_MODE_CLOUD_REACHABLE'].includes(mode)
    && payload.metadata?.source !== 'offline_pos';
}

export async function submitRestaurantPrint(payload) {
  const { token, mode } = readContext();
  if (!token || ['null', 'undefined'].includes(token) || mode !== 'CLOUD_MODE') {
    return { ok: false, error: 'No se puede solicitar la impresion en el estado actual de la sesion.' };
  }
  // Assign once to this request object, so an HTTP retry retains its identity.
  payload.metadata = { ...(payload.metadata || {}) };
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(payload.metadata.print_job_id || '')) {
    payload.metadata.print_job_id = (typeof crypto !== 'undefined' && crypto.randomUUID?.())
      || 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
        const value = Math.floor(Math.random() * 16);
        return (character === 'x' ? value : (value & 3) | 8).toString(16);
      });
  }
  const request = {
    job_id: payload.metadata.print_job_id,
    event_key: payload.metadata.print_event,
    ticket_type: payload.ticket_type || 'generic',
    html_content: payload.html_content || payload.htmlContent || '',
    text_fallback: payload.content || '',
    metadata: payload.metadata,
  };
  for (let attempt = 0; attempt < 2; attempt += 1) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/v1/api/app/print-broadcasts`, request,
        { headers: { Authorization: `Bearer ${token}` }, timeout: 10000 },
      );
      return { ...response.data, printed: false, results: [], virtual_actions: [] };
    } catch (error) {
      if (attempt === 0 && !error.response) continue;
      // Never fall back to localhost/browser after an uncertain server result:
      // the durable request may already be printing on several installations.
      return { ok: false, error: error.response?.data?.error
        || 'No se pudo confirmar el envio al restaurante. Consulta los trabajos de impresion antes de repetirlo.' };
    }
  }
}
